import { ChangeEvent, FunctionComponent, ReactElement, type SVGProps } from 'react';
import { Component as CloseIcon } from 'icons/icon-ui--close.svg';
import styles from './Notification.module.scss';

type Props = {
    icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    text: string;
    onClose?: (e?: ChangeEvent<HTMLInputElement>) => void;
    onClick?: () => void;
    hasCloseButton?: boolean;
};

export function Notification({
  icon: Icon,
  text,
  onClose,
  onClick,
  hasCloseButton = true,
}: Props): ReactElement {
  return (
    <div>
      <div
        role="button"
        tabIndex={0}
        className={`${styles.notification_button} ${onClick ? styles.allow_click : ''}`}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') onClick?.();
        }}
      >
        <div className={styles.icon_wrapper}>
          <Icon />
        </div>
        <span className={styles.text}>{text}</span>
        {hasCloseButton && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onClose?.();
          }}
          className={styles.close_button}
        >
          <CloseIcon width={20} height={20} />
        </button>
        )}
      </div>
    </div>
  );
}
